var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header"),_c('div',{staticClass:"container document-body"},[_vm._t("body"),(_vm.isLoading)?_c('base-loader',{attrs:{"block":"","large":""}}):_vm._e(),_vm._t("navigation")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }